// These custom events share the product ID and pixel client/session with
// Shopify's confirmed product_added_to_cart event. Never count a CTA click as an add.
for (const panel of document.querySelectorAll('[data-lr-experiment]')) {
  let exposed = false;
  // Preview and explicit QA sessions use separate event names in GA4.
  function isQA() {
    if (window.Shopify?.designMode) return true;
    const query = new URL(location.href).searchParams;
    const marked = query.has('preview_theme_id') || query.get('lr_pdp_qa') === '1';
    try {
      if (marked) sessionStorage.setItem('lr_pdp_qa_v1','1');
      return marked || sessionStorage.getItem('lr_pdp_qa_v1') === '1';
    } catch { return marked; }
  }
  function data(variantId) {
    return {experiment:'lr_pdp_stacked_v1',arm:panel.dataset.lrArm,size_count:Number(panel.dataset.lrSizeCount),
      qa:isQA(),product_id:panel.dataset.lrExperiment,variant_id:variantId || null};
  }
  function publish(name, variantId) {
    const shop = window.Shopify;
    if (!shop?.customerPrivacy?.analyticsProcessingAllowed?.() || !shop.analytics?.publish) return false;
    shop.analytics.publish(name, data(variantId));
    return true;
  }
  function exposure() {
    if (!exposed) exposed = publish('lr_pdp_viewed');
  }
  exposure();
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], exposure);
  document.addEventListener('visitorConsentCollected', exposure);
  window.addEventListener('load', exposure, {once:true});
  panel.addEventListener('click', event => {
    const radio = event.target;
    if (panel.dataset.lrSizeCount === '1' || !event.isTrusted || !radio.matches('input[type=radio]') ||
        !radio.closest('variant-radios,[data-size-picker]')) return;
    exposure();
    const variants = radio.closest('variant-radios')?.querySelector('[type="application/json"]');
    const id = variants ? JSON.parse(variants.textContent).find(v => v.option1 === radio.value)?.id : radio.value;
    if (exposed) publish('lr_pdp_size_selected', String(id));
  });
  panel.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('product-form form') || event.defaultPrevented) return;
    const id = new FormData(form).get('id');
    if (!id || !exposed || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    // Shopify honours return_to after a successful native cart add. A failed
    // POST has no such landing. A short-lived nonce also ties it to this tab.
    if (form.querySelector('[name="return_to"]:not([data-lr-return])')) return;
    try {
      const nonce = crypto.randomUUID();
      const record = {d:data(String(id)), nonce, time:Date.now()};
      sessionStorage.setItem('lr_pdp_pending_v1',JSON.stringify(record));
      let target = form.querySelector('[data-lr-return]');
      if (!target) {
        target = document.createElement('input');
        target.type = 'hidden';
        target.name = 'return_to';
        target.dataset.lrReturn = '';
        form.appendChild(target);
      }
      target.value = (window.Shopify?.routes?.root || '/')+'cart#lr-pdp-'+nonce;
    } catch { return; }
    publish('lr_pdp_add_requested',String(id));
  });
}
